import { render, staticRenderFns } from "./FibryoLogoSVG.vue?vue&type=template&id=4ec97986"
import script from "./FibryoLogoSVG.vue?vue&type=script&lang=js"
export * from "./FibryoLogoSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports